import B_VariableReal from '../../../../base/dev/child/attr/B_VariableReal';
import R_Define from '../../util/R_Define';

const init = () => {
    return class R_VariableReal extends B_VariableReal {
        constructor(obj) {
            // 만약 변수 id가 '속도'라면 기본 값 2, 최소 값 0, 최대 값 5 지정
            if (obj.id === R_Define.VARIABLES.SPEED) {
                obj.value = R_Define.DEFAULT_SPEED;
                obj.min = R_Define.MIN_SPEED;
                obj.max = R_Define.MAX_SPEED;
            }

            super(obj);
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/child/attr/R_VariableReal.js